"use client";

import { useRouter } from "next/navigation";
import { useAppSelector } from "@/redux/store";
import React, { useEffect, useRef, useState } from "react";
import { usePathname } from "next/navigation";
import { getIntialials } from "@/helpers/utils/utility-functions";
import Loader from "@/app/_components/Loader";
import Image from "next/image";
import * as _ from "lodash";
import Search from "@/app/_components/Search/Search";
import styles from "./Navbar.module.css";
import NotificationPopup from "../notification/NotificationPopup";
import { MenuItem } from "@/models/menuItem";
import DashboardIcon from "../../../../public/images/navbar/dashboard.svg";
import ScheduleIcon from "../../../../public/images/navbar/schedule.svg";
import PassIcon from "../../../../public/images/navbar/passes.svg";
import LineUpIcon from "../../../../public/images/navbar/lineup.svg";
import GetInvolvedIcon from "../../../../public/images/navbar/get-involved.svg";
import ChatIcon from "../../../../public/images/navbar/chat.svg";
import PartnerIcon from "../../../../public/images/navbar/chat.svg";
import MarketPlaceIcon from "../../../../public/images/navbar/marketPlace.svg";
import OrdersIcon from "../../../../public/images/navbar/orders.svg";
import { ALL_VERTICALS } from "@/models/PassEvent";
// import ComingSoonIcon from "../../../../public/images/navbar/coming_soon.svg";


const initialMenu: MenuItem[] = [
  {
    name: "Home",
    href: "/dashboard",
    IconComponent: DashboardIcon
  },
  {
    name: "Schedule",
    href: "/schedule",
    IconComponent: ScheduleIcon
  },
  {
    name: "My Pass",
    href: "/passes",
    IconComponent: PassIcon
  },
  {
    name: "My Orders",
    href: "/orders",
    IconComponent: OrdersIcon
  },
  {
    name: "Lineup",
    href: "/lineup",
    IconComponent: LineUpIcon
  },
  {
    name: "Get Involved",
    href: "/get-involved",
    IconComponent: GetInvolvedIcon
  },
  {
    name: "Chat",
    href: "/chat",
    IconComponent: ChatIcon
  },

  {
    name: "MarketPlace",
    href: "/marketplace",
    IconComponent: MarketPlaceIcon
  },
];

const partnerMenu: MenuItem[] = [
  {
    name: "Partner Portal",
    href: "/partner-portal",
    IconComponent: PartnerIcon
  },
];

const eventsMenu: MenuItem[] = [
  {
    name: "All Events",
    href: "/schedule",
  },
  ...ALL_VERTICALS.map((vertical) => ({
    name: _.startCase(vertical),
    href: `/verticals/${vertical}`,
  })),
];

const upcomingMenu: MenuItem[] = [
  // {
  //   name: "MarketPlace",
  //   href: "/",
  //   IconComponent: MarketPlaceIcon
  // },
];

const profileItem = {
  name: "Profile",
  href: "/profile",
  icon: "/images/navbar/user-placeholder-pic.svg",
  selectedIcon: "/images/navbar/user-placeholder-pic.svg",
};

export default function NewNavbar({ show, setter }: any) {
  const router = useRouter();
  const upcomingChildRef = useRef<any>(null);
  const pathname = usePathname();

  const userData = useAppSelector((state) => state.appReducer.userData);
  const selectedTag = useAppSelector(
    (state) => state.dashboardReducer.selectedCategory
  );

  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [isEventsMenuOpen, setIsEventsMenuOpen] = useState(true);

  const [isNotificationOpen, setIsNotificaitonOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const handleInitialMenuItemClick = async (index: number) => {
    const selectedMenuItem = initialMenu[index];
    if (selectedMenuItem.href) {
      router.push(selectedMenuItem.href);
    } else if (selectedMenuItem.fn) {
      selectedMenuItem.fn();
    }
    setter(false);
  };

  const handlePartnerMenuItemClick = async (index: number) => {
    const selectedMenuItem = partnerMenu[index];
    if (selectedMenuItem.href) {
      router.push(selectedMenuItem.href);
    } else if (selectedMenuItem.fn) {
      selectedMenuItem.fn();
    }
    setter(false);
  };

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsNotificaitonOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  return (
    <>
      {isSearchOpen && (
        <Search
          setIsSearchOpen={(value) => {
            setter(false);
            setIsSearchOpen(value);
          }}
        />
      )}

      <div
        className={`h-screen pt-7 px-5 flex-col flex bg-white bg-opacity-30`}
      >
        <div className="flex justify-between items-center">
          <Image
            height={34}
            width={80}
            className="mt-0"
            src="/images/C-Tribe_Main_Logo.svg"
            alt="c-tribe"
          />
          {/* Search and notification icons */}
          <div className="flex items-start cursor-pointer ml-14">
            <div
              className="h-[20px] w-[20px] relative"
              id="searchicon"
              onClick={() => setIsSearchOpen(true)}
            >
              <Image
                fill
                className="mt-0"
                src="/images/search_icon.svg"
                alt="c-tribe"
              />
            </div>

            <div
              ref={ref}
              className="ml-5 relative notification-button"
              onClick={() => {
                setIsNotificaitonOpen(!isNotificationOpen);
              }}
            >
              <Image
                height={20}
                width={20}
                src="/images/notification_icon.svg"
                alt="c-tribe"
              />
              {isNotificationOpen && (
                <div
                  style={{
                    position: 'absolute',
                    top: '0px',
                    right: '5px',
                    zIndex: 1000, // Set a high z-index to ensure it appears above other elements
                  }}
                >
                  <NotificationPopup
                    onClose={() => setIsNotificaitonOpen(false)}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="h-screen flex-col flex overflow-y-scroll no-scrollbar">

          {initialMenu.map((item, index) => {
            const IconComponent = item.IconComponent;
            const isSelected = pathname === item.href;
            const iconColor = isSelected ? "#333E48" : "#909090";
            const eventsActive = eventsMenu.some(
              (eventItem) => pathname === eventItem.href
            );

            return (
              <div key={index}>
                <div
                  className={`cursor-pointer flex justify-start items-center`}
                  onClick={() => handleInitialMenuItemClick(index)}
                >
                  <div className="flex items-center justify-start mt-[1.75rem]">
                    {IconComponent && (
                      <IconComponent width={20} height={20} style={{ color: iconColor }} />
                    )}
                    <span
                      className={`ml-[12px] text-[14px] ${pathname === item.href
                        ? "font-bold text-black"
                        : "font-normal text-[#909090]"
                        } ${pathname == item.href ? "" : styles.unselectedMenuItem}`}
                    >
                      {item.name}
                    </span>
                  </div>
                </div>

                {item.href === "/schedule" && (
                  <div className="mt-4">
                    <button
                      type="button"
                      className="flex w-full items-center justify-between"
                      onClick={() => setIsEventsMenuOpen((prev) => !prev)}
                    >
                      <div className="flex items-center justify-start">
                        <ScheduleIcon
                          width={20}
                          height={20}
                          style={{ color: eventsActive ? "#333E48" : "#909090" }}
                        />
                        <span
                          className={`ml-[12px] text-[14px] ${
                            eventsActive
                              ? "font-bold text-black"
                              : "font-normal text-[#909090]"
                          } ${eventsActive ? "" : styles.unselectedMenuItem}`}
                        >
                          Events
                        </span>
                      </div>
                      <Image
                        src={
                          isEventsMenuOpen
                            ? "/images/keyboard-up.svg"
                            : "/images/keyboard-down.svg"
                        }
                        width={16}
                        height={16}
                        alt="Toggle events menu"
                      />
                    </button>
                    {isEventsMenuOpen && (
                      <div className="mt-4 flex flex-col gap-4 pl-8">
                        {eventsMenu.map((eventItem, eventIndex) => {
                          const isEventSelected = pathname === eventItem.href;
                          return (
                            <div
                              key={eventIndex}
                              className="cursor-pointer flex justify-start items-center"
                              onClick={() => {
                                if (eventItem.href) {
                                  router.push(eventItem.href);
                                }
                                setter(false);
                              }}
                            >
                              <span
                                className={`text-[14px] ${
                                  isEventSelected
                                    ? "font-bold text-black"
                                    : "font-normal text-[#909090]"
                                } ${isEventSelected ? "" : styles.unselectedMenuItem}`}
                              >
                                {eventItem.name}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                )}
              </div>
            );

          })}

          {userData?.role === "partner" &&
            partnerMenu.map((item, index) => {
              const IconComponent = item.IconComponent;
              const isSelected = pathname === item.href;
              const iconColor = isSelected ? "#333E48" : "#909090";
              return (
                <div
                  key={index}
                  className={`cursor-pointer flex justify-start items-center mt-[1.75rem]`}
                  onClick={() => handlePartnerMenuItemClick(index)}
                >
                  <div className="flex items-center justify-start mt-6">
                    {IconComponent && (
                      <IconComponent width={20} height={20} style={{ color: iconColor }} />
                    )}
                    <span
                      className={`ml-[12px] text-[14px] ${pathname === item.href
                        ? "font-bold text-black"
                        : "font-normal text-[#909090]"
                        } ${pathname == item.href ? "" : styles.unselectedMenuItem}`}
                    >
                      {item.name}
                    </span>
                  </div>
                </div>

              )

            })}

          {/* <hr className="mr-4 mt-6 h-[1px] border-t-0 bg-[#C4C4C4]" />

          <div className="flex items-center justify-start mt-8">

            <ComingSoonIcon width={20} height={20} style={{ color: '#333E48' }} />

            <span className={`ml-[12px] text-[14px] font-medium text-black`}>
              Coming Soon
            </span> 
          </div> */}

          <div
            className={`flex flex-col justify-between items-start`}
            ref={upcomingChildRef}
          >
            <div className="flex flex-col gap-7">
              {upcomingMenu.map((item, index) => {
                const IconComponent = item.IconComponent;
                const isSelected = pathname === item.href;
                const iconColor = isSelected ? "#333E48" : "#909090";
                return (
                  <div key={index} className={`flex justify-start items-center`}>
                    <div className={`flex items-center justify-start mt-6`}>
                      {IconComponent && (
                        <IconComponent width={20} height={20} style={{ color: iconColor }} />
                      )}
                      <span
                        className={`ml-[12px] text-[14px] font-normal ${styles.upcomingMenuItem}`}
                      >
                        {item.name}
                      </span>
                      {/* {
                    selectedIndex === index ?
                      <div className="h-[3px] w-[30px] bg-black  mt-1"></div> : null
                  } */}
                    </div>
                  </div>

                )

              })}
            </div>

            {/* <div className="mt-auto"></div> */}
          </div>

          <div
            className="flex flex-col cursor-pointer pb-10 md:mt-auto mt-20"
            onClick={() => {
              setter(false);
              router.push(profileItem.href);
            }}
          >
            <div className={`flex items-center justify-start ml-2`}>
              <div className="h-[45px] w-[45px] rounded-[10px] ml-[-6px] bg-black flex justify-center items-center">
                {/* <img
                      className="w-[45px] h-[45px] rounded-[10px]"
                      src={item.icon}
                      alt="Profile picture" /> */}
                <h1 className="navbar-profile-gradient-background text-center text-[16px] font-bold text-white">
                  {getIntialials(userData?.firstName, userData?.lastName)}
                </h1>
              </div>

              <div className="mt-1 ml-2 flex flex-col justify-center">
                <span className="text-black font-medium text-[13px]">{`${_.capitalize(
                  userData?.firstName
                )} ${_.capitalize(userData?.lastName)}`}</span>
                <span className="text-[#00000080] font-normal text-[12px] mt-0">
                  View Account
                </span>
              </div>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}
